import {
  BrowserRouter as Router,
  RouterProvider,
} from "react-router-dom";
import router from "./Routes/Route";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AppRoute from "./Routes/Route";
import DisableBrowserAutofill from "./Components/DisableBrowserAutofill";
import PermissionBootstrap from "./Components/PermissionBootstrap";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DisableBrowserAutofill />
      <PermissionBootstrap />
      <AppRoute />
    </LocalizationProvider>
  );
}
export default App;
